import CantileverCard from 'components/CantileverCard'
import { FileUploader } from 'features/files'
import React, { useMemo } from 'react'
import { GeckoEntry } from 'types'

interface FileUploadPanelProps {
  entry: GeckoEntry
}

export const FileUploadPanel: React.FC<FileUploadPanelProps> = ({ entry }) => {
  const tags: Record<string, string> = useMemo(() => {
    const nonNullTags = Object.fromEntries(
      Object.entries(entry.tags).filter(([, value]) => value !== null) as [
        string,
        string,
      ][]
    )

    return {
      ...nonNullTags,
      [entry.type]: entry.id,
    }
  }, [entry.type, entry.tags, entry.id])

  return (
    <CantileverCard>
      <CantileverCard.CardHeader leadingContent='File Upload' />
      <CantileverCard.Section topPadding bottomPadding>
        <FileUploader
          entry={entry}
          tags={tags}
          showExistingFiles={false} // Don't show existing files in upload panel
          acceptedFileTypes={['*/*']}
          multiple={true}
        />
      </CantileverCard.Section>
    </CantileverCard>
  )
}
